<template>
  <div class="c-topCsvLottery" v-if="previews.length !== 0">
    <div class="c-topCsvLottery__title">駐車場等抽選状況</div>
    <ul class="c-topCsvLottery__cards">
      <div v-for="(preview, i) in previews" :key="`c-topCsvLottery__card` + i">
        <div class="c-topCsvLottery__cards__card">
          <div class="c-topCsvLottery__cards__card__item">
            {{ preview[1] }}:
          </div>
          <div class="c-topCsvLottery__cards__card__item">
            {{ preview[3] }}
          </div>
          <div class="c-topCsvLottery__cards__card__item">
            {{ preview[4] }}
          </div>
        </div>
      </div>
    </ul>
    <div class="c-topCsvLottery__aside">
      ＊施設使用には、別途契約の締結が必要です。管理会社により送付される契約書をご確認ください。
    </div>
  </div>
</template>

<script>
import LoadCsvFromPublic from "../mixin/loadCsvFromPublic";

export default {
  mixins: [LoadCsvFromPublic],
  data: function() {
    return {
      previews: [],
    };
  },
  async mounted() {
    const csvs = await this.getCsv("lottery");
    const ROOM_NO_COLUMUN_INDEX = 2;
    const ROOM_TYPE_COLUMUN_INDEX = 3;
    const LOTTERY_NUMBER_COLUMUN_INDEX = 4;

    const currentUserRoomNumberData = csvs.filter(
      csv => csv[ROOM_NO_COLUMUN_INDEX] === this.currentUser.roomNo,
    );

    const setCurrentUserRoomNumberData = currentUserRoomNumberData.filter(
      csv =>
        csv[ROOM_TYPE_COLUMUN_INDEX] !== "" ||
        csv[LOTTERY_NUMBER_COLUMUN_INDEX] !== "",
    );

    console.log("setCurrentUserRoomNumberData", setCurrentUserRoomNumberData);

    this.previews = setCurrentUserRoomNumberData;
  },
};
</script>
